<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">You will need:</p>

      <ul class="default-list">
        <li>
          A word-processing application or website such as Microsoft Word, Google Docs, TextEdit,
          Pages or Notepad
        </li>
      </ul>
      <p class="mb-5">
        Great teachers are able to establish and maintain standards of behaviour for a classroom
        that mean their students are happy, safe and ready to learn.
      </p>
      <p class="mb-5">
        Each teacher usually develops their standards of behaviour based on how they teach. There
        are non-negotiables of course, but there is some flexibility allowed.
      </p>
      <p class="mb-5">
        For this activity, imagine that you are a teacher writing a note for a substitute or cover
        teacher telling them how your classroom should be run.
      </p>
      <p class="mb-5">This guide should include notes about:</p>

      <ul class="default-list mb-10">
        <li>What language is tolerated in the classroom</li>
        <li>
          The level of conversational noise in the classroom when you are teaching or when students
          are engaging in independent work
        </li>
        <li>How the desks should be arranged</li>
        <li>What equipment students are expected to use and have</li>
        <li>Procedures if students need to use the bathroom</li>
        <li>How and when students can ask questions about the course material.</li>
      </ul>

      <fileupload-button-immediate
        v-model="uploaded_files['uploaded_file_1']"
        :is-editable="isEditable"
        filetype="doc"
        index="1"
        key="1"
      />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      login_type: localStorage.getItem('login_type'),
      uploaded_files: {
        uploaded_file_1: '',
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
